import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalLink"] */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/BenefitsSection/arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/BenefitsSection/fish.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/BenefitsSection/rocket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/depthLeft.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/depthRight.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/EasyLaunchSection/1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/EasyLaunchSection/2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/EasyLaunchSection/3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/EasyLaunchSection/4.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/engage.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/format.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/header.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/header/headerWaveMobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/assets/header/headerWaveTablet.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/components/AdvertiseBottomSection/AdvertiseBottomSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/components/AdvertiseformatSection/AdvertiseformatSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/views/Advertise/components/BenefitsSection/BenefitsSection.module.css");
